import { render, staticRenderFns } from "./StartLearning.vue?vue&type=template&id=ed64e140"
import script from "./StartLearning.vue?vue&type=script&lang=js"
export * from "./StartLearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports